<template>
  <div class="flex flex-col items-center py-8" data-testid="ai-agents-module">
    <div class="text-zinc-400 dark:text-zinc-500 bg-zinc-100 dark:bg-zinc-700 p-4 rounded-full mb-6">
      <Icon name="ai.robot" size="lg" />
    </div>

    <h1 class="mb-3 font-bold text-center text-3xl text-zinc-900 dark:text-zinc-100">AI Agents</h1>

    <p class="max-w-xl mb-10 text-xl text-center text-zinc-700 dark:text-zinc-300 px-2">
      Unlock better video workflows with Zight and 10x your productivity and client support. Let us know your interest below and get in our private beta!
    </p>

    <iframe
      v-if="dashboardAgentsVideoUrl"
      :src="dashboardAgentsVideoUrl"
      allowtransparency="true"
      allowfullscreen
      style="border: medium none"
      frameborder="0"
      class="w-full sm:rounded-lg aspect-video sm:w-144 mb-10"
    />

    <div class="flex flex-col items-center gap-2">
      <Button data-testid="ai-agents-interest-button" type="solid" variant="blue" target="_blank" :href="typeformUrl" @click="handleJoinWaitlist">
        Join the Waitlist
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { Button, Icon } from '@/storybook';
import { getRequest } from '@/ApiHelpers';
import { useTrack } from '@/composables/useTrack';
import { useUserStore } from '@/store/useUserStore';
import { useOrganizationStore } from '@/store/useOrganizationStore';

const dashboardAgentsVideoUrl = ref('');

const { track } = useTrack();
const userStore = useUserStore();
const organizationStore = useOrganizationStore();
const { id: userId, email } = storeToRefs(userStore);
const { id: orgId, ownerId, planCode } = storeToRefs(organizationStore);

onMounted(async () => {
  track('dashboard_agents_viewed', {
    user_id: userId.value,
    email: email.value,
    org_id: orgId.value,
  });

  try {
    const response = await getRequest('/api/v5/dropper_configurations/dashboard_agents_video_url');
    const content = response?.data?.dropperConfiguration?.attributes?.content;
    if (content) {
      dashboardAgentsVideoUrl.value = content;
    }
  } catch {
    // Config not set yet, video embed stays hidden
  }
});

const handleJoinWaitlist = () => {
  track('feature_access_request', {
    feature_name: 'ai-agents',
    user_id: userId.value,
    email: email.value,
    org_id: orgId.value,
    owner_id: ownerId.value,
    plan: planCode.value,
  });
};

const typeformUrl = computed(() => {
  const base = 'https://form.typeform.com/to/NQIKYtnA?typeform-source=share.zight.com';
  if (email.value) {
    return `${base}&email=${encodeURIComponent(email.value)}`;
  }
  return base;
});
</script>
